import { render } from "./icon-video-chat.svg?vue&type=template&id=80de7630"
const script = {}
script.render = render

export default script